import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import RoutesWrapper from "./RoutesWrapper";
import { AuthProvider } from "./context/AuthContext";
import { PermissionsProvider } from "./context/PermissionsContext";
import { MinimizedPopupProvider } from "./context/MinimizedPopupContext";
import { Provider as ReduxProvider } from "react-redux";
import { QueryClientProvider } from '@tanstack/react-query';
import { store } from "./store";
import { queryClient } from "./query/queryClient";
import { useWebSocketCacheInvalidation } from "./query/hooks/useWebSocketCache";
import { useInactivityLogout } from "./utils/useInactivityLogout";
import { Toaster } from "sonner";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorBoundary from "./Components/ErrorBoundary";

function InnerApp() {
  useInactivityLogout();
  return <RoutesWrapper />;
}

function AppContent() {
  useWebSocketCacheInvalidation();

  return (
    <AuthProvider>
      <PermissionsProvider>
        <Router>
          <MinimizedPopupProvider>
            <InnerApp />
          </MinimizedPopupProvider>
        </Router>
      </PermissionsProvider>
    </AuthProvider>
  );
}

function App() {
  return (
    <>
      <div className="app-container">
        <div className="background-color"></div>
        <div className="content-container">
          <ReduxProvider store={store}>
            <QueryClientProvider client={queryClient}>
              <ErrorBoundary reloadOnChunkError>
                <AppContent />
              </ErrorBoundary>
            </QueryClientProvider>
          </ReduxProvider>
        </div>
      </div>

      {/* Global ToastContainer - appears above all modals */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{ zIndex: 9999999 }}
        toastClassName="!z-[9999999]"
      />
      <Toaster
        position="top-right"
        expand
        richColors
        closeButton
        style={{ zIndex: 999999999 }}
        toastOptions={{
          style: { zIndex: 999999999 },
        }}
      />
    </>
  );
}

export default App;
